import OWContainer from 'styles/styled-components/ow-container';
import { CompanyForm } from '../components/company-form';
import useController from '../controllers/add-company-controller';
import { Spinner } from 'components/design';

export const AddCompanyRoute = () => {
    const { formData, companyOwners, onSubmit, onCancel, onChange, isLoading, isAddCompanyLoading, errors, cities } =
        useController();

    return (
        <OWContainer>
            {isLoading ? (
                <Spinner />
            ) : (
                <CompanyForm
                    formData={formData}
                    companyOwners={companyOwners}
                    cities={cities}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    onChange={onChange}
                    isSaveLoading={isAddCompanyLoading}
                    errors={errors}
                />
            )}
        </OWContainer>
    );
};
